export function emailValidator(email) {
  const re = /\S+@\S+\.\S+/
    if (!email) return "Kérlek minden mezőt megfelelően tölts ki."
    if (!re.test(email)) return 'Kérlek add meg az e-mail címed.'
  return ''
}
